import React from 'react';
import ModuleImagePage from '../shared/ModuleImagePage.jsx';

const UserAnalytics = () => <ModuleImagePage moduleKey="user-analytics" />;

export default UserAnalytics;
